import {get} from "./base";

// 预约分享
export function getSubscribeInfo(id){
    return get('/v3/expert/' +id,)
}

export function getWXAppId(url){
    return get('/api/weCom/we/signature?url=' +url,)
}


/**
 * 获取点播专题详情--转发
 * @param id
 * @param data  dIntro:介绍和目录 directory:目录 comment:评论 dynamic:动态 is_open=0没开启动态is_open=1开启动态     默认值 dIntro
 * @returns {Promise<unknown | void>}
 */
export function getVideoShareList(id,data){
    return get('/v3/app/vod/' +id,data)
}

/**
 * 获取点播视频详情--转发
 * @param id
 * @param data
 * @returns {Promise<* | void>}
 */
export function getLiveShareList(id,data){
    return get('/v3/app/vod/video/'+id,data)
}
// 转发评论
export function getCommunityInfo(id){
    return get('/v3/app/community/comment/'+id)
}
